<template>
  <div>
    <div class="option" :style="{color: heartColor}" @click.stop="onClickAdd()" :key="itemId" v-if="!isFav">
      <Icon name="star-o"></Icon>
    </div>
    <div class="option" :style="{color: heartColor}" @click.stop="onClickRemove()" :key="itemId" v-else>
      <Icon name="star"></Icon>
    </div>
  </div>
</template>

<script>
  import {Toast, Icon} from "vant"

  export default {
    name: "Favorite",
    components: {
      Icon
    },
    props: {
      item: {},
      color: {},
    },

    data() {
      return {
        itemId: 0,
        isFav: false,
        listType: "favorite",
        heartColor:  "#fc9153",
      }
    },

    mounted() {
      if (this.color) {
        this.heartColor = this.color
      }
    },

    methods: {
      checkFavorite() {
        if (!this.item || !this.item.id) {
          return false
        } else if (!this.item.item_list) {
          return false
        } else if (!this.item.item_list.favorite) {
          return false
        } else {
          return true
        }
      },
      onClickAdd() {
        let params = {
          item_id: this.itemId,
          action: "add",
          list_type: this.listType,
        }
        this.$store.dispatch("UpdateItemList", params).then((data) => {
          if (data.code === 0) {
            Toast("加入收藏")
            this.isFav = true
          } else if (data.code === 20010) {
            Toast("未登录")
          } else {
            Toast("系统错误")
          }
        }, () => {
          Toast("网络异常")
        })
      },
      onClickRemove() {
        this.isFav = false
        let params = {
          item_id: this.itemId,
          action: "remove",
          list_type: this.listType,
        }
        this.$store.dispatch("UpdateItemList", params).then((data) => {
          if (data.code === 0) {
            Toast("取消收藏")
          } else {
            Toast("系统错误")
          }
        }, () => {
          Toast("网络异常")
        })
      },
    },
    watch: {
      item() {
        this.isFav = this.checkFavorite()
        this.itemId = this.item.id
      }
    }

  }

</script>

<style lang="scss" scoped>

  .option {
    color:  #fc9153;
    font-size: 16px;
  }

</style>
